import { AccountRoutesType } from "../../navigationUtils";
export const filterMenuItems = (menuItems, hideAddresses, hideBillingInformation) => {
    return menuItems
        .filter((mi) => {
        // Hide link to addresses if configured to do so
        if (hideAddresses && mi.to === AccountRoutesType.ADDRESSES) {
            return false;
        }
        // Hide link to billing information if configured to do so
        if (hideBillingInformation && mi.to === AccountRoutesType.BILLING_INFO) {
            return false;
        }
        // Hide incorrectly configured links.
        if (mi.to === null)
            return false;
        // If it passes all conditions, return true
        return true;
    })
        .map((item) => ({
        to: item.to,
        displayText: item.displayText,
        menuItems: item.menuItems,
    }));
};
